import SideBar from './SideBar'
export default SideBar
